import React from 'react';
import cx from 'classnames';
import { useNavigate } from 'react-router-dom';

import Icons from '@/icons';
import { iconConstants, routesConstants, tagConstants } from '@/constants';

import styles from './songStatus.module.scss';

interface SongStatusProps {
  status: string;
  reason?: string;
}

const SongStatus = (props: SongStatusProps) => {
  const navigate = useNavigate();
  const { status, reason } = props;

  const STATUS_VS_FRONTENDSTATUS: { [key: string]: string } = {
    PENDING: 'Pending',
    REJECTED: 'Decline',
    ACCEPTED: 'Approved',
    // Add more mappings as needed
  };

  const STATUS_COLOR_MAP: { [key: string]: tagConstants.COLORS } = {
    PENDING: 'blue',
    ACCEPTED: 'green',
    REJECTED: 'red',
    // Add more mappings as needed
  };

  const colorType: tagConstants.COLORS = STATUS_COLOR_MAP[status] || 'gray';

  const { bgColor, fontColor } = tagConstants.TAG_VS_COLORS[colorType];

  return (
    <div
      className={cx(styles.songStatus, { [styles.decline]: status === 'REJECTED' })}
      style={{
        backgroundColor: bgColor,
        color: fontColor,
        paddingLeft: status === 'REJECTED' ? 4 : 0,
      }}
    >
      {STATUS_VS_FRONTENDSTATUS[status]}
      {status === 'REJECTED' && (
        <Icons className={styles.icon} type={iconConstants.ICONS.DECLINEICON} />
      )}
      <div className={styles.declineResuslt}>
        <p className={styles.desc1}>{reason}</p>
        <p className={styles.desc2}>
          If we have made some mistake?
          <button
            style={{
              all: 'unset',
              cursor: 'pointer',
              textDecorationLine: 'underline',
            }}
            onClick={() => navigate(routesConstants.ROUTES.CONTACT_US)}
          >
            Contact us
          </button>
        </p>
      </div>
    </div>
  );
};

export default SongStatus;
